"use client";

import { SessionProvider } from "next-auth/react";
import { ReactNode } from "react";

/**
 * Client-side wrapper that provides SessionProvider for components
 * that need session data but are rendered outside of ClientsideLayout.
 * This is specifically for Navigation which contains LeadCaptureBannerWrapper.
 */
export function SessionWrapper({ children }: { children: ReactNode }) {
  return (
    <SessionProvider refetchInterval={60} refetchOnWindowFocus>
      {children}
    </SessionProvider>
  );
}
